import styled from '@emotion/styled';
import { CopyIcon } from 'src/assets/new-icon/CopyIcon';
import { MoreIcon } from 'src/assets/new-icon/MoreIcon';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

export const AutomationWrapper = styled('div', { label: 'AutomationWrapper' })`
    background-color: #edf3f9;
    margin: -25px;
    padding: 10px 25px;
`;
export const AutomationItemWrapper = styled('div', { label: 'AutomationItemWrapper' })`
    background-color: #ffffff;
    padding: 10px 20px;
    margin: 10px 0;
`;

export const ErrorWrapper = styled('div', { label: 'ErrorWrapper' })`
    color: red;
`;

export const FilterWrapper = styled('div', { label: 'FilterWrapper' })`
    display: flex;
    margin: 3px 0;
    font-size: 0.75rem;
    padding: 0 5px;
`;

export const ItemsWrapper = styled('div', { label: 'ItemsWrapper' })`
    display: flex;
`;

export const SchedulerWrapper = styled('div', { label: 'SchedulerWrapper' })`
    display: flex;
    align-items: baseline;
    padding: 0 25px;
`;

export const ActionsWrapper = styled('div', { label: 'ActionsWrapper' })`
    margin-bottom: 25px;
`;
export const FilterKey = styled('div', { label: 'FilterKey' })`
    font-weight: bold;
    padding: 3px 7px;
    font-size: 0.75rem;
`;

export const FilterData = styled('div', { label: 'FilterData' })`
    background: #ececec;
    font-weight: bold;
    padding: 3px 7px;
    border-radius: 2px;
    font-size: 0.6875rem;
    margin: 0 5px;
`;

export const ControlsWrapper = styled('div', { label: 'ControlsWrapper' })`
    display: flex;
    align-items: baseline;
    width: 100%;
    padding: 10px 0;
`;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    margin: 0 15px 0 0;
`;

export const ScheduleButton = styled(Button, { label: 'ScheduleButton' })`
    margin: 0 3px 0 3px;
`;

export const ScheduleText = styled('p', { label: 'ScheduleText' })`
    font-size: 12px;
    font-weight: bold;
    margin: 0 0 3px 0;
`;

export const DisabledText = styled('span', { label: 'DisabledText' })`
    color: #a94442;
`;

export const EnabledText = styled('span', { label: 'EnabledText' })`
    color: #5c9454;
`;

export const NameWrapper = styled('h3', { label: 'NameWrapper' })`
    cursor: pointer;
`;
export const HistoryHeader = styled('tr', { label: 'HistoryHeader' })`
    background-color: #64748b;
    width: 100%;
    padding: 10px 5px;
`;

export const HistoryHeaderCell = styled('th', { label: 'HistoryHeaderCell' })`
    color: white;
    font-weight: bold;
`;

export const HeaderBodyCell = styled('td', { label: 'HeaderBodyCell' })`
    border: #eae6e6 1px solid;
    font-size: 0.75rem;
`;

export const HeaderBodyRow = styled('tr', { label: 'HeaderBodyRow' })`
    &:nth-child(2n+1) {
        background-color: #ebeef2;
    }
`;

export const SaveIconStyled = styled(CopyIcon, { label: 'SaveIconStyled' })`
    height: 18px;
    width: 18px;
    fill: #0D1246FF;
    margin: 2px 5px;
`;

export const CopyIconStyled = styled(MoreIcon, { label: 'CopyIconStyled' })`
    width: 18px;
    height: 18px;
    fill: #0D1246FF;
    margin: 2px 5px;
`;

export const EventsIdsWrapper = styled('div', { label: 'EventsIdsWrapper' })`
`;

export const EventsDetailsWrapper = styled('div', { label: 'EventsDetailsWrapper' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const IconWrapper = styled('div', { label: 'IconWrapper' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const LogErrorWrapper = styled('div', { label: 'LogErrorWrapper' })`
    color: rgba(255, 0, 0, 0.74);
`;
